import BasicButton from "components/BasicInputs/BasicButton";
import { useFormikContext } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../store/store";
import { MaterialSchema } from "../validation";
import { appSetAlert } from "../../../../store/actions/appAction";
import { apiSaveManufactureOrder, apiUpdateManufactureOrder } from "api/manufactureOrderApi";
import { useEffect } from "react";
import { formatPrice } from "helpers/dataFormat";
import useCurrency from "helpers/useCurrency";
import useResponsive from "helpers/useResponsive";
import { calculateFinalPrice } from "../utils";

export default function Footer() {
  const dispatch = useAppDispatch();
  const store = useAppSelector((x: any) => x);
  const navigate = useNavigate();
  const { values, setFieldValue } = useFormikContext<MaterialOrderData>();
  const token = store?.businessReducer?.business?.token;
  const { defCur } = useCurrency();
  const { isMobile } = useResponsive();
  const { id } = useParams() ?? { id: undefined };

  useEffect(() => {
    const finalPrice = calculateFinalPrice(
      values.tableTotalPrice,
      Number(values.quantity),
      values.costs,
      values.wages
    );
    setFieldValue("finalPrice", finalPrice);
  }, [values.tableTotalPrice, values.costs, values.wages, values.quantity]);

  return (
    <div
      className={`z-[3] mt-36 flex items-center justify-between w-full p-4 px-8 bg-white rounded-md md:px-20 shadow-proportional ${
        isMobile ? "mb-32 flex-col gap-4" : "sticky bottom-0"
      }`}
    >
      <div className="flex items-center gap-4">
        <span className="text-lg font-medium pl-6 border-[#ABBACC] border-l">کل هزینه تولید</span>
        <span className="">{formatPrice(values.finalPrice)}</span>
        <span className="text-dark-3">{defCur.en_title}</span>
      </div>

      <div className="flex gap-6">
        {(values.status === undefined || values.status === "پیش نویس") && (
          <BasicButton
            variant="outlined"
            color="disabled"
            onClick={() => {
              const isValid = MaterialSchema.safeParse(values);
              if (!isValid.success) {
                dispatch(appSetAlert("موارد ضروری را وارد کنید", "error"));
                return;
              }

              if (values.isEdit) {
                if (id === undefined) return;
                dispatch(apiUpdateManufactureOrder(id, { ...values, status: "پیش نویس" }, token, navigate));
                //TODO: update to reducer
              } else {
                dispatch(
                  apiSaveManufactureOrder(
                    {
                      ...values,
                      status: "پیش نویس",
                      CurrencyId: defCur.id,
                      CurrencyExchange: defCur.currencyExchange || 1,
                    },
                    token,
                    navigate
                  )
                );
                //TODO: add to reducer
              }
            }}
          >
            <span>{values.isEdit ? "ثبت پیش نویس" : "پیش نویس"}</span>
          </BasicButton>
        )}
        {(values.status === undefined || values.status === "پیش نویس") && (
          <BasicButton
            variant="contained"
            onClick={() => {
              const isValid = MaterialSchema.safeParse(values);
              if (!isValid.success) {
                dispatch(appSetAlert("موارد ضروری را وارد کنید", "error"));
                return;
              }
              if (values.automaticRemmitance && values.remmitanceWarehouseId === undefined) {
                dispatch(appSetAlert("موارد ضروری را وارد کنید", "error"));
                return;
              }

              if (values.isEdit) {
                if (id === undefined) return;
                dispatch(apiUpdateManufactureOrder(id, { ...values, status: "تایید شده" }, token, navigate));
                //TODO: update to reducer
              } else {
                dispatch(
                  apiSaveManufactureOrder(
                    {
                      ...values,
                      status: "تایید شده",
                      CurrencyId: defCur.id,
                      CurrencyExchange: defCur.currencyExchange || 1,
                    },
                    token,
                    navigate
                  )
                );
                //TODO: add to reducer
              }
            }}
          >
            <span>{values.isEdit ? "ثبت نهایی" : "ذخیره"}</span>
          </BasicButton>
        )}
      </div>
    </div>
  );
}
